export default "__VITE_ASSET__BJS1HL3t__"